<template>
    <div class="sustainable-component module-app">
        <div class="container">
            <v-select bg-color="white" variant="outlined"  label="Moduler" :items="modules" v-model="selectedModuleIndex" item-title="Name" item-value="ModuleId"></v-select>
            <div v-if="selectedModule != null">
                <div v-for="childSection in selectedModule.ChildSections" :key="'childSection' + childSection.SubSectionId">
                    <v-expansion-panels variant="accordion">
                        <v-expansion-panel v-bind:class="'theme-' + childSection.Color">
                            <v-expansion-panel-title v-bind:color="childSection.Color">
                                {{childSection.Name}}
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div style="position:relative; width:100%; min-height:100px;">
                                    <div v-html="childSection.TextContent"></div>
                                    <div class="dropdown pull-right" style="position:absolute;top:0px;right:0px">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="addSubSection(childSection.SubSectionId,selectedModule.ModuleId)">Lägg till</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateSubSection(childSection)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteSubSection(childSection)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                                <v-expansion-panels variant="accordion" v-for="grandchildSection in childSection.ChildSections" :key="'grandchildSection' + grandchildSection.SubSectionId">
                                    <v-expansion-panel v-bind:class="'theme-' + grandchildSection.Color">
                                        <v-expansion-panel-title v-bind:color="grandchildSection.Color">
                                            {{grandchildSection.Name}}
                                        </v-expansion-panel-title>
                                        <v-expansion-panel-text>
                                            <div style="position:relative; width:100%; min-height:100px;">
                                                <div v-html="grandchildSection.TextContent"></div>
                                                <div class="dropdown pull-right" style="position:absolute;top:0px;right:0px">
                                                    <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                        ...
                                                    </a>
                                                    <div class="dropdown-menu dropdown-menu-right">
                                                        <a href="javascript:void(0)" class="dropdown-item" @click="addSubSection(grandchildSection.SubSectionId,selectedModule.ModuleId)">Lägg till</a>
                                                        <a href="javascript:void(0)" class="dropdown-item" @click="updateSubSection(grandchildSection)">Ändra</a>
                                                        <a href="javascript:void(0)" class="dropdown-item" @click="deleteSubSection(grandchildSection)">Ta bort</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <v-expansion-panels variant="accordion" v-for="grandgrandchildSection in grandchildSection.ChildSections" :key="'grandgrandchildSection' + grandgrandchildSection.SubSectionId">
                                                <v-expansion-panel v-bind:class="'theme-' + grandgrandchildSection.Color">
                                                    <v-expansion-panel-title v-bind:color="grandgrandchildSection.Color">
                                                        {{grandgrandchildSection.Name}}
                                                    </v-expansion-panel-title>
                                                    <v-expansion-panel-text>
                                                        <div style="position:relative; width:100%; min-height:100px;">
                                                            <div v-html="grandgrandchildSection.TextContent"></div>
                                                            <div class="dropdown pull-right" style="position:absolute;top:0px;right:0px">
                                                                <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    ...
                                                                </a>
                                                                <div class="dropdown-menu dropdown-menu-right">
                                                                    <a href="javascript:void(0)" class="dropdown-item" @click="addSubSection(grandgrandchildSection.SubSectionId,selectedModule.ModuleId)">Lägg till</a>
                                                                    <a href="javascript:void(0)" class="dropdown-item" @click="updateSubSection(grandgrandchildSection)">Ändra</a>
                                                                    <a href="javascript:void(0)" class="dropdown-item" @click="deleteSubSection(grandgrandchildSection)">Ta bort</a>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <v-expansion-panels variant="accordion" v-for="grandgrandgrandchildSection in grandgrandchildSection.ChildSections" :key="'grandgrandgrandchildSection' + grandgrandgrandchildSection.SubSectionId">
                                                            <v-expansion-panel>
                                                                <v-expansion-panel-title v-bind:color="grandgrandgrandchildSection.Color">
                                                                    {{grandgrandgrandchildSection.Name}}
                                                                </v-expansion-panel-title>
                                                                <v-expansion-panel-text>
                                                                    <div style="position:relative; width:100%; min-height:100px;">
                                                                        <div v-html="grandgrandgrandchildSection.TextContent"></div>
                                                                        <div class="dropdown pull-right" style="position:absolute;top:0px;right:0px">
                                                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                ...
                                                                            </a>
                                                                            <div class="dropdown-menu dropdown-menu-right">
                                                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateSubSection(grandgrandgrandchildSection)">Ändra</a>
                                                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteSubSection(grandgrandgrandchildSection)">Ta bort</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </v-expansion-panel-text>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>

                                                    </v-expansion-panel-text>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </v-expansion-panel-text>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-text>
                        </v-expansion-panel>

                    </v-expansion-panels>
                </div>
                <div class="mt-1 mb-3" v-if="selectedModule != null">
                    <v-btn size="default" color="primary" class="btn-primary" @click="addSubSection(-1,selectedModule.ModuleId)">
                        Lägg till sektion till modulen
                    </v-btn>
                </div>

            </div>
            <div class="mt-3" style="margin-bottom:100px;">
                <v-btn size="default" class="btn-warning"  @click="printCode">
                    Rendrera modul
                </v-btn>
                <v-checkbox :model="printMainNav" label="Print main nav"></v-checkbox>
            </div>
        </div>
        <UpdateModule ref="updateModuleDialogue" @moduleupdated="reloadContent()"></UpdateModule>
        <UpdateSubSection ref="updateSubSectionDialogue"  @subsectionupdated="reloadContent()"></UpdateSubSection>
    </div>
</template>


<script>

    import UpdateSubSection from "./update-subsection.vue";
    import UpdateModule from "./update-module.vue";
    import ModuleService from "../../Services/ModuleService";

    import { ref } from 'vue'
    //const internalModel = ref({
    //    Modules: []
    //})

    const modules = ref([]);
    const updateModuleDialogue = ref(null);
    const updateSubSectionDialogue = ref(null);

    export default {
        name: 'module-app',
        props: {
            model: Object
        },
        components:{
            UpdateModule,
            UpdateSubSection
        },
        methods: {
            async reloadContent() {
                var newModel = await ModuleService.getModules();
                modules.value = newModel.Modules;
                for (var i = 0; i < modules.value.length; i++) {
                    if (modules.value[i].ModuleId == this.selectedModule.ModuleId) {
                        this.selectedModule = modules.value[i];
                    }
                }
            },
            async deleteSubSection(item) {
                await ModuleService.deleteSubSection(item.SubSectionId);
                this.reloadContent();
            },
            addModule() {
                this.updateModuleDialogue.create();
            },
            updateModule() {
                this.updateModuleDialogue.open(this.selectedModule);
            },
            addSubSection(parentId, moduleid) {
                this.updateSubSectionDialogue.create(parentId, moduleid);
            },
            updateSubSection(item) {
                this.updateSubSectionDialogue.open(item);
            },
            async printCode() {
                this.newWindow = window.open('/module/printCode?moduleid=' + this.selectedModule.ModuleId + '&printMainNav=' + this.printMainNav, '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
        },

        data() {
            return {
                selectedModuleIndex: null,
                selectedModule: null,
                printMainNav:false,
            };
        },
        watch: {
            selectedModuleIndex: function (newVal) {
                for (var i = 0; i < modules.value.length; i++) {
                    if (modules.value[i].ModuleId == newVal) {
                        this.selectedModule = modules.value[i];
                    }
                }
            },

            //selectedPosition1: function(newVal){
            //    this.getWorkTasks(newVal);
            //    this.getWorkBlocks(newVal);
            //},
           
        },
        mounted() {
            //this.internalModel = this.model;
            modules.value = this.model.Modules;
            alert("Fixa marginal mt-5 i regelverk och ta bort attribut med internal model")
            alert("Ta bort br i mångkunnighet")
            alert("Ta bort tom p i Individuell lönedel och Rörlig lönedel")
        },
        setup() {
            //const workDialog = ref()
            //return { workDialog }
            return { updateModuleDialogue, updateSubSectionDialogue, modules }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
